import { render } from "./InsightsFeedback.vue?vue&type=template&id=84d07c18&scoped=true"
import script from "./InsightsFeedback.vue?vue&type=script&lang=js"
export * from "./InsightsFeedback.vue?vue&type=script&lang=js"

import "./InsightsFeedback.vue?vue&type=style&index=0&id=84d07c18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d07c18"]])

export default __exports__